import { render, staticRenderFns } from "./promptBox.vue?vue&type=template&id=880c6f3e&scoped=true"
import script from "./promptBox.vue?vue&type=script&lang=js"
export * from "./promptBox.vue?vue&type=script&lang=js"
import style0 from "./promptBox.vue?vue&type=style&index=0&id=880c6f3e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c6f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('880c6f3e')) {
      api.createRecord('880c6f3e', component.options)
    } else {
      api.reload('880c6f3e', component.options)
    }
    module.hot.accept("./promptBox.vue?vue&type=template&id=880c6f3e&scoped=true", function () {
      api.rerender('880c6f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/examCenterOwn/onlineExamOwn/module/promptBox.vue"
export default component.exports